import { cn } from '@/lib/utils';

export { MobileFooterButton } from './mobile-footer-button';

export function MobileFooter({
  children,
  className,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        'flex h-12 flex-row justify-evenly gap-2 sm:hidden',
        className,
      )}
    >
      {children}
    </div>
  );
}
